import { ToggleListSort } from '../components/inventory/toggle-list-sort.vue';
Vue.component('toggle-list-sort', ToggleListSort);